// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"LoginForm_containerPrincipal__HdxAV","form":"LoginForm_form__Bg85Q","fourth":"LoginForm_fourth__8WyrI","error":"LoginForm_error__dGcLc"};